import { KCBobcatLogo } from '@/components/icons/KCBobcatLogo'
import Image from 'next/image'
import { titanPrompts } from './titanPrompts'
import { kcbobcatPrompts } from './kcbobcatPrompts'
import { Message } from 'ai'
import { legacyEquipmentPrompts } from './legacyEquipmentPrompts'
import { ignitePrompts } from './ignitePrompts'

export const themes = {
  titan: {
    title: 'Titan Chat',
    api: '/api/titan',
    primary: '#C00000',
    accent: '#2B4D5F',
    secondary: '#000000',
    questions: titanPrompts,
    showCallButton: true,
    liveChatEnabled: true,

    logo: (
      <Image
        alt="titan-machinery-logo"
        width={124}
        height={32}
        className="h-8"
        src={'/images/titan-machinery-logo.webp'}
      ></Image>
    ),
    starterMessages: [
      {
        content:
          '$50,000!!!We are offering up to $50,000 in tuition, scholarships and tools to people who love to work on equipment.  Do you know anyone looking for a job?',
        id: '1',
        role: 'assistant',
        parts: [
          {
            type: 'text',
            text: 'We are offering up to $50,000 in tuition, scholarships and tools to people who love to work on equipment.  Do you know anyone looking for a job?'
          },
          {
            type: 'tool-invocation',
            toolInvocation: {
              toolCallId: '2',
              state: 'result',
              toolName: 'careerDevelopment',
              result: {
                link: 'https://www.titanmachinery.com/titan-careers/careers',
                text: 'Titan Career Development'
              },
              args: {}
            }
          }
        ]
      },
      {
        content: 'What can I help you with today?',
        id: '3',
        role: 'assistant'
      }
    ] as Message[]
  },
  kcbobcat: {
    title: 'KC Bobchat',
    api: '/api/kcbobcat',
    primary: '#FF3300',
    accent: '#7E7E7E',
    secondary: '#000000',
    questions: kcbobcatPrompts,
    logo: <KCBobcatLogo />,
    starterMessages: [
      {
        content: 'Welcome to KC Bobcat Chat!',
        id: '1',
        role: 'assistant'
      },
      {
        content: 'What can I help you with today?',
        id: '3',
        role: 'assistant'
      }
    ] as Message[],
    showCallButton: false,
    liveChatEnabled: true
  },
  legacy: {
    title: 'Legacy Equipment Chat',
    api: '/api/legacyequipment',
    primary: '#ffffff',
    accent: '#008000',
    secondary: '#000000',
    questions: legacyEquipmentPrompts,
    liveChatEnabled: false,
    logo: (
      <img
        alt="legacy-equipment-logo"
        className="h-10"
        src={'/images/legacy-equipment-logo.png'}
      ></img>
    ),
    starterMessages: [
      {
        content: 'Welcome to Legacy Equipment Chat!',
        id: '1',
        role: 'assistant'
      },
      {
        content: 'What can I help you with today?',
        id: '3',
        role: 'assistant'
      }
    ] as Message[]
  },
  ignite: {
    title: 'Ignite Attachments Chat',
    api: '/api/ignite',
    primary: '#2186EA',
    accent: '#2186EA',
    secondary: '#000000',
    questions: ignitePrompts,
    liveChatEnabled: false,
    logo: (
      <img
        alt="ignite-attachments-logo"
        className="h-10"
        src={'/images/ignite-attachments-logo.png'}
      ></img>
    ),
    starterMessages: [
      {
        content: 'Welcome to Ignite Attachments Chat!',
        id: '1',
        role: 'assistant'
      },
      {
        content: 'What can I help you with today?',
        id: '3',
        role: 'assistant'
      }
    ] as Message[]
  }
}

export type Subdomains = keyof typeof themes
